import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const measureListSelector = createSelector(
  (state: RootState) => state.measure.measureList,
  (measureList) => measureList,
);

export const isEnableLoadingSelector = createSelector(
  (state: RootState) => state.measure,
  (item) => item.nextToken !== '',
);

export const isInitSelector = createSelector(
  (state: RootState) => state.measure,
  (item) => item.nextToken !== null,
);
